// Highest first. Membership itself is an unordered set.
export const accountRoleOptions = [
  {value: 'admin', label: 'Admin'},
  {value: 'reviewer', label: 'Reviewer'},
  {value: 'manager', label: 'Manager'},
  {value: 'editor', label: 'Editor'},
];
